<script>
import PickKupecInline from '@/components/PickKupecInline';
import { format, addDays, setMinutes, setHours, getHours, getMinutes } from 'date-fns';
import service from '@/service';
import _ from 'lodash';
import settings from '@/settings.js';
import numeral from 'numeral';

export default {
	components: {
		'pick-kupec-inline': PickKupecInline
	},
	props: {
		prodajalci: Array,
		kupci: Array
	},
	methods: {
		showModal: function (type, izbranDatum, izdajaId, prodajalec, kupec, voziloExt, voziloInt, ogrodje, libelleModele, libelleVersion, opomba) {
			this.izdaja_id = null;
			if (izdajaId) {
				this.izdaja_id = izdajaId;
			}
			this.clearModalData();
			if (type === 0) {
				// add to first available slot
			} else if (type === 1) {
				// add on selected slot
				this.datum_izdaje = setHours(setMinutes(izbranDatum, 0), 0);
				this.cas_izdaje = {
					HH: numeral(getHours(izbranDatum)).format('00'),
					mm: numeral(getMinutes(izbranDatum)).format('00')
				};
			} else if (type === 2) {
				// edit
				this.datum_izdaje = setHours(setMinutes(izbranDatum, 0), 0);
				this.cas_izdaje = {
					HH: numeral(getHours(izbranDatum)).format('00'),
					mm: numeral(getMinutes(izbranDatum)).format('00')
				};
				this.ok_title = this.ACTION_TITLE_EDIT;
			}
			// prodajalec
			this.prodajalci_selected = null;
			if (prodajalec) {
				// select existing user
				for (let item of this.vsiProdajalci) {
					if (prodajalec === item.id) {
						this.prodajalci_selected = item;
						break;
					}
				}
			} else {
				// select current user
				for (let item of this.vsiProdajalci) {
					if (this.user.email === item.email) {
						this.prodajalci_selected = item;
						break;
					}
				}
			}
			// kupec
			if (kupec) {
				this.$nextTick(() => {
					this.$refs.pickKupec.select(kupec);
				});
			} else {
				this.$nextTick(() => {
					this.$refs.pickKupec.select(null);
				});
			}
			// vozilo
			if (voziloInt) {
				// interno vozilo
				let vozilo = this.voziloDefValue();
				vozilo.id = voziloInt;
				vozilo.ogrodje = ogrodje;
				vozilo.libelle_modele = libelleModele;
				vozilo.libelle_version = libelleVersion;
				this.vozilo_selected = vozilo;
			} else if (voziloExt) {
				// externo vozilo
				let vozilo = this.voziloDefValue();
				vozilo.ogrodje = voziloExt;
				this.vozilo_selected = vozilo;
			}
			// opomba
			if (opomba) {
				this.opomba = opomba;
			}
			// enable editing for super admins
			if (this.user.role === 5) {
				this.prodajalci_disabled = false;
			}
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			evt.preventDefault();
			if (!this.prodajalci_selected) {
				this.showError('Prodajalec ni izbran');
				return;
			}
			if (!this.vozilo_selected) {
				this.showError('Vozilo ni izbrano');
				return;
			}
			if (!this.kupec_selected) {
				this.showError('Kupec ni izbran');
				return;
			}
			if (!this.datum_izdaje) {
				this.showError('Datum izdaje ni izbran');
				return;
			}
			if (!this.cas_izdaje) {
				this.showError('Čas izdaje ni izbran');
				return;
			}
			// submit izdaja
			let datumIzdaje = this.parseDatumInCas(this.datum_izdaje, this.cas_izdaje);
			let voziloInt = null;
			let voziloExt = null;
			if (this.vozilo_selected.id > 0) {
				voziloInt = this.vozilo_selected.id;
			} else {
				voziloExt = this.vozilo_selected.ogrodje;
			}
			this.showError(null);
			this.in_progress = true;
			service.dodajIzdajo(this.izdaja_id, this.prodajalci_selected, this.kupec_selected, datumIzdaje, voziloInt, voziloExt, this.opomba)
				.then(response => {
					this.$refs.modal.hide();
					this.clearModalData();
					this.$emit('izdaja-success', response.izdaja);
				})
				.catch(error => {
					this.in_progress = false;
					this.processAddError(error);
				});
		},
		click_odstrani: function (evt) {
			if (!this.izdaja_id) {
				this.showError('Odstranitev ni mogoča');
				return;
			}
			// submit odstrani
			this.showError(null);
			this.in_progress = true;
			service.odstraniIzdajo(this.izdaja_id)
				.then(response => {
					this.$refs.modal.hide();
					this.clearModalData();
					this.$emit('izdaja-removed', response.izdaja);
				})
				.catch(error => {
					this.in_progress = false;
					this.processRemoveError(error);
				});
		},
		parseDatumInCas: function (datum, cas) {
			return format(setHours(setMinutes(datum, cas.mm), cas.HH), settings.dbDtFormat);
		},
		clearModalData: function () {
			this.vozilo_selected = null;
			this.kupec_selected = null;
			this.datum_izdaje = null;
			this.cas_izdaje = null;
			this.opomba = null;
			this.action_message_type = null;
			this.action_message = null;
			this.in_progress = false;
			this.ok_title = this.ACTION_TITLE_ADD;
		},
		loadProdajalci: function () {
			this.prodajalci_options = [];
			service.getProdajalci()
				.then(prodajalci => {
					for (let item of prodajalci) {
						item.full_name = item.first_name + ' ' + item.last_name;
					}
					this.prodajalci_options = prodajalci;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
				});
		},
		voziloSelect_change: function (value) {
			if (value) {
				if (value.p_kupec) {
					this.$refs.pickKupec.select(value.p_kupec);
				} else {
					this.$refs.pickKupec.select(null);
				}
			} else {
				this.$refs.pickKupec.select(null);
			}
		},
		vozilaSelect_createOption: function (value) {
			let vozilo = this.voziloDefValue();
			vozilo.ogrodje = value;
			return vozilo;
		},
		vozilaSelect_search: function (search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		},
		voziloDefValue: function () {
			return {
				id: -1,
				ogrodje: '',
				libelle_modele: 'Nov model',
				libelle_version: 'Nova verzija'
			};
		},
		vozilaSelect_load: _.debounce((loading, search, vm) => {
			loading(true);
			service.searchVozila(search)
				.then(vozila => {
					loading(false);
					vm.vozila_options = vozila;
				})
				.catch(error => {
					loading(false);
					if (error) {
						console.log(error);
					}
				});
		}, 500),
		processAddError: function (error) {
			if (!error) {
				this.showError('Napaka pri izdaji (G)');
				return;
			}
			console.log(error);
			if (!error.response || !error.response.status || error.response.status !== 400) {
				this.showError('Izdaja ni uspela (S)');
				return;
			}
			if (!error.response.data || !error.response.data.code || !error.response.data.message) {
				this.showError('Izdaja ni uspela (U)');
				return;
			}
			this.showError(`${error.response.data.message} (#${error.response.data.code})`);
		},
		processRemoveError: function (error) {
			if (!error) {
				this.showError('Napaka pri odstranjevanju (G)');
				return;
			}
			console.log(error);
			this.showError('Napaka pri odstranjevanju (R)');
		},
		showError: function (message) {
			this.action_message_type = this.ACTION_TYPE_ERROR;
			this.action_message = message;
		},
		getCasIzdajeText: function () {
			let resultText = '';
			if (this.cas_izdaje != null) {
				if (this.cas_izdaje.HH != null) {
					resultText += this.cas_izdaje.HH + ' : ';
				} else {
					resultText += '-- : ';
				}
				if (this.cas_izdaje.mm != null) {
					resultText += this.cas_izdaje.mm;
				} else {
					resultText += '--';
				}
				return resultText;
			} else {
				return '';
			}
		}
	},
	data: function () {
		return {
			vozilo_selected: null,
			vozila_options: [],
			izdaja_id: null,
			prodajalci_disabled: true,
			prodajalci_selected: null,
			prodajalci_options: null,
			kupec_selected: null,
			action_message_type: null,
			action_message: null,
			datum_izdaje: null,
			cas_izdaje: null,
			opomba: '',
			ok_title: '',
			in_progress: false,
			ACTION_TITLE_ADD: 'Dodaj',
			ACTION_TITLE_EDIT: 'Spremeni',
			ACTION_TYPE_ERROR: 'ERROR'
		}
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		vsiProdajalci () {
			if (this.prodajalci != null) {
				this.prodajalci_options = this.prodajalci;
			} else {
				if (this.prodajalci_options == null) {
					this.loadProdajalci();
				}
			}
			return this.prodajalci_options;
		},
		dateRange () {
			let nowDate = new Date();
			return {
				min: addDays(nowDate, 1),
				max: addDays(nowDate, 31)
			};
		},
		userCanEdit () {
			if (settings.isProdajalec(this.user.role) || settings.isSekretar(this.user.role) || settings.isModerator(this.user.role) || settings.isRacunovodja(this.user.role) || settings.isAdmin(this.user.role) || settings.isSkrbnikGum(this.user.role)) {
				return true;
			} else {
				return false;
			}
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" title="Izdaja vozila" class="modal-primary" @ok="onOkModal">
		<b-form ref="form">
			<b-row>
				<b-col>
					<b-form-group>
						<label>Prodajalec</label>
						<v-select ref="prodajalci"
							v-model="prodajalci_selected"
							:options="vsiProdajalci"
							:disabled="prodajalci_disabled"
							label="full_name"
							placeholder="Izberi prodajalca ...">
						</v-select>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group>
						<label>Vozilo<span class="model_name" v-if="(vozilo_selected && vozilo_selected.id > 0)"> {{ vozilo_selected.libelle_modele }} ({{ vozilo_selected.libelle_version }})</span></label>
						<v-select ref="vozila"
							:disabled="!userCanEdit"
							v-model="vozilo_selected"
							:options="vozila_options"
							:create-option="vozilaSelect_createOption"
							:taggable="true"
							:filterable="false"
							label="ogrodje"
							@input="voziloSelect_change"
							@search="vozilaSelect_search"
							placeholder="Izberi vozilo ...">
							<template slot="no-options">Vnesite VIN številko vozila</template>
							<template slot="option" slot-scope="option">
								{{ option.ogrodje }}
							</template>
							<template slot="selected-option" slot-scope="option">
								{{ option.ogrodje }}
							</template>
						</v-select>
					</b-form-group>
				</b-col>
			</b-row>
			<pick-kupec-inline ref="pickKupec" v-model="kupec_selected" :userCanEdit="userCanEdit" :kupci="kupci" title="Kupec" />
			<b-row>
				<b-col>
					<b-form-group label="Datum izdaje*:" label-for="datum_izdaje">
						<v-date-picker
							v-if="userCanEdit"
							ref="datum_izdaje"
							id="datum_izdaje"
							v-model="datum_izdaje"
							:is-required="true"
							:input-props='{
								class: "form-control dt_border gdt_border",
								placeholder: "DD. MM. YYYY",
								required: true
							}'
							:min-date="dateRange.min"
							:max-date="dateRange.max"
							mode="single"
							locale="sl-SI" />
						<b-form-input v-else type="text" :value="datum_izdaje | hr_date" disabled></b-form-input>
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Čas izdaje*:" label-for="cas_izdaje">
						<v-timepicker
							v-if="userCanEdit"
							ref="cas_izdaje"
							id="cas_izdaje"
							v-model="cas_izdaje"
							format="HH : mm"
							:hour-range="[7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]"
							hide-disabled-hours
							:minute-interval="30"
							placeholder="HH : MM"
							input-class="form-control" />
						<b-form-input v-else type="text" :value="getCasIzdajeText()" disabled></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group>
						<label for="opomba">Opomba</label>
						<b-form-input id="opomba"
							:disabled="!userCanEdit"
							type="text"
							v-model="opomba"
							max="5000"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-alert :variant="action_message_type && action_message_type === ACTION_TYPE_ERROR ? 'danger' : 'primary'" :show="action_message && action_message !== ''">{{ action_message }}</b-alert>
		</b-form>
		<template slot="modal-footer" slot-scope="{ ok, cancel }">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="start">
						<b-button v-if="izdaja_id != null && userCanEdit" variant="warning" @click.stop="click_odstrani" :disabled="in_progress">Odstrani</b-button>
					</b-col>
					<b-col align-self="end" class="ma_pos">
						<b-button variant="secondary" @click="cancel()" :disabled="in_progress">Prekliči</b-button>
						<b-button v-if="userCanEdit" variant="primary" @click="ok()" :disabled="in_progress">{{ ok_title }}</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>
<style>
.gdt_border {
	border: 1px solid #c2cfd6!important;
}
</style>
<style scoped>
.model_name {
	font-weight: bold;
}
.ma_pos {
	text-align: end;
}
.dt_border {
	border: 1px solid #c2cfd6!important;
}
.vue__time-picker {
	font-family: inherit!important;
}
.vue__time-picker >>> input.display-time {
	border: 1px solid #c2cfd6 !important;
	padding: 0.375rem 0.75rem !important;
	font-size: 0.875rem !important;
	height: inherit!important;
}
.vue__time-picker >>> .dropdown ul li:not([disabled]).active, .vue__time-picker >>> .dropdown ul li:not([disabled]).active:hover {
	background: #20a8d8!important;
}
</style>


// WEBPACK FOOTER //
// src/components/IzdajaModal.vue